import { CommonOutletTemplate } from "UI/CommonOutletTemplate";
import { OverviewAnalitycs } from "./OverviewAnalitycs";

export const Analytics = () => {
  return (
    <CommonOutletTemplate title="Analytics">
      <OverviewAnalitycs  />
    </CommonOutletTemplate>
  );
};
